import React from 'react';
import { Stack } from '@mui/material';
import { AirportPickup } from './AirportPickup';
import { TemporaryHousing } from './TemporaryHousing';

const EventCardContent = ({ event, ...props }) => {
  const {
    Registration_Detail: { servicesRequested },
  } = event;
  return (
    <Stack spacing={2}>
      {servicesRequested.airportPickup && (
        <AirportPickup request={event} {...props} />
      )}
      {servicesRequested.temporaryHousing && (
        <TemporaryHousing request={event} {...props} />
      )}
    </Stack>
  );
};

export { EventCardContent };
